import React from 'react'
import AnimatedSVG from '../AnimatedSVG/AnimatedSVG';
import Modals from '../Modals/Modals';
import SecBTN from '../SecBTN';
import classes from './SuccessModal.module.css'

const SuccessModal = ({ show, onHide, title, btnTxt }) => {
  return (
    <Modals className={classes.modal} show={show} onHide={onHide}>
      <AnimatedSVG />
      <p className="text-center">{title}</p>
      <div className="text-center mt-2">
        <SecBTN className={classes["yes-btn"]} onClick={onHide}>
          {btnTxt}
        </SecBTN>
      </div>
    </Modals>
  );
}

export default SuccessModal
